/**
 * Кастомная иконка «Сердце» — filled heart
 *
 * fill="currentColor" для окрашивания через Tailwind
 * Совместима с IconComponent (принимает size, style, className)
 */

import type { CSSProperties } from 'react';

interface IconProps {
  className?: string;
  size?: number | string;
  style?: CSSProperties;
}

export function HeartIcon({ className, size, style }: IconProps): JSX.Element {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.1385 2.31347C15.7738 1.55349 13.6178 2.18662 12 4.0905C10.381 2.18438 8.22505 1.55461 5.86262 2.31347C2.87629 3.2699 1.01364 5.95397 1.0001 9.31719C0.973022 15.0805 6.54743 19.5955 11.7721 21.899L12.0011 22L12.2302 21.899C17.4559 19.5955 23.0281 15.0805 22.9999 9.31719C22.9864 5.95397 21.1237 3.2699 18.1385 2.31347Z"
        fill="currentColor"
      />
    </svg>
  );
}
